import { Trans, useTranslation } from 'react-i18next';

import {
    Anchor,
    Body1,
    Box,
    Modal,
} from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import { DeniedDescription } from './DeniedDescription';

export const AppealRedeterminationDescription = ({
    trackingNumber,
    appealBeforeDate,
    rationale,
    appealed,
    paId,
}: {
    trackingNumber?: string | null;
    appealBeforeDate?: string | null;
    rationale?: string | null;
    appealed?: boolean;
    paId: string;
}) => {
    const { t } = useTranslation();
    const [opened, { toggle }] = useDisclosure();

    return (
        <Box>
            <Body1>
                {appealed ? (
                    <Trans
                        i18nKey="priorAuthorization.statusPage.appealed.description"
                        components={{
                            1: <Anchor onClick={toggle} />,
                        }}
                    />
                ) : (
                    <Trans
                        i18nKey="priorAuthorization.statusPage.redetermination.description"
                        components={{
                            1: <Anchor onClick={toggle} />,
                        }}
                    />
                )}
            </Body1>
            <Modal
                title={t('priorAuth.decisionDetails.modal.title')}
                opened={opened}
                onClose={toggle}
            >
                <DeniedDescription
                    trackingNumber={trackingNumber}
                    appealBeforeDate={appealBeforeDate}
                    rationale={rationale}
                    paId={paId}
                />
            </Modal>
        </Box>
    );
};
